import { Environment } from './environment';

const environment: Environment = {
  envName: import.meta.env.MODE,
  baseUrl: import.meta.env.BASE_URL,
  siteUrls: {
    bom: 'https://www.bom.gov.au',
    dpp: `https://${import.meta.env.VITE_DPP_DOMAIN}`,
    wmw: `https://${import.meta.env.VITE_SITE_DOMAIN}`,
    data: 'https://data.gov.au'
  },
  flags: {
    FIXTURE_RECENT_TRADES: false,
    FIXTURE_DECISIONS: false,
    ENABLE_SHARE_URLS: true
  },
  assetUrls: {
    globalAlertsRemote: `https://${import.meta.env.VITE_COMMON_ENV_STACK}/assets/wm_alerts.json`,
    landingPageResourcesRemote: `https://${import.meta.env.VITE_COMMON_ENV_STACK}/assets/wm-download-files.json`,
    baseDownloadFilePathRemote: `https://${import.meta.env.VITE_COMMON_ENV_STACK}/`
  },
  configuration: {
    DECISIONS_PAGE: 5
  }
};

Object.freeze(environment);

const getEnvironment = (): Environment => environment;
const getFlags = (): Record<string, boolean> | undefined => environment?.flags;
const isFlagEnabled = (flag: string): boolean => !!environment?.flags?.[flag];

export { environment, getEnvironment, getFlags, isFlagEnabled };
